import React, { useEffect } from 'react'
import { Views } from '../../views'
import { connect, useDispatch } from 'react-redux'
import { get } from 'lodash'
import { routersHelper, setCookie } from '../../helpers'
import { CONNECT_SOCKET, SET_LANGUAGE } from '../../redux/actions/type'
import i18n from '../../i18n'


const Lobby = ({ keycloak, authenticated, language, lobbyLists, switchLanguage }) => {
    const { Lobby } = Views
    const { useRouter } = routersHelper
    const router = useRouter()
    const dispatch = useDispatch()
    const newLobbyLists = lobbyLists.map(item => {
        item.showNoti = false
        return item
    })

    useEffect(() => {
        dispatch({
            type: CONNECT_SOCKET,
            payload: {
                name: router.query,
                dispatch
            }
        })

        // eslint-disable-next-line
    }, [])

    //default Thai Language.
    useEffect(() => {
        const changeLanguage = (lng) => {
            i18n.changeLanguage(lng)
            setCookie('language', lng)
            switchLanguage(lng)
        }
        changeLanguage('th')
    }, [switchLanguage])

    return (

        <Lobby
            keycloak={keycloak}
            authenticated={authenticated}
            language={language}
            lobbyLists={newLobbyLists}

        />
    )
}

const mapStateToProps = state => ({
    keycloak: get(state, 'keycloak', ''),
    authenticated: get(state, 'keycloak.authenticated', false),
    language: get(state, 'language', 'th'),
    lobbyLists: get(state, 'lobby.lobbyLists', []),
})

const mapDispatchToProps = dispatch => ({
    switchLanguage: (lang) => {
        dispatch({
            type: SET_LANGUAGE,
            payload: lang
        })
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(Lobby)